<mat-list>
  <mat-list-item>
    <span class="w-100 text-center">You have no notifications</span>
  </mat-list-item>
</mat-list>
